import { AvailableLanguages, LANGUAGES } from '@core/components/header/lang-selection/lang-selection.config';
import { featureFlags } from '@shared/constants/feature-flags';

export const defaultLanguageFn = (): AvailableLanguages => {
  if (featureFlags.translationFeatureFlag) {
    return LANGUAGES.map((value) => value.lang as string).includes(navigator.language.split('-')[0])
      ? (navigator.language.split('-')[0] as AvailableLanguages)
      : 'es';
  } else {
    return 'es';
  }
};
